export default "__VITE_ASSET__2d2b23db__"